export const ACTION_TYPES = {
  GET_FILE_DOWNLOAD_SIGNED_URL_REQUEST_SUCCESS: 'GET_FILE_DOWNLOAD_SIGNED_URL_REQUEST_SUCCESS'
};
